import { Button, Card, Input, Form } from 'antd';
import React from 'react';
import { API_KEY } from '../../constants';
import axios from 'axios';
import gql from 'graphql-tag';
import firebase from 'firebase/app';
import LoadingSpinner from '../../utils/LoadingSpinner';
import { notificationService } from '../ui/NotificationService';
import { useSubscription } from 'react-apollo';
import { CheckCircleTwoTone } from '@ant-design/icons';

export const GET_ALL_ESTUDIANTES = gql`
	subscription GetEstudiantes {
		estudiantes {
			key
			firebase_uid
			nombre
			active
			grupo_key
			password
			curso {
				year
				key
				nivel
				identificadorNivel
			}
			colegio {
				nombre
				key
			}
		}
	}
`;

const SignInStudent = () => {
	const [passwordValue, setPasswordValue] = React.useState<string>('');
	const [customLoader, setCustomLoader] = React.useState<boolean>(false);
	const { data, loading, error } = useSubscription(GET_ALL_ESTUDIANTES);

	if (loading || error) {
		return <LoadingSpinner type="pacman"></LoadingSpinner>;
	}

	if (customLoader) {
		return <LoadingSpinner type="grid"></LoadingSpinner>;
	}

	const match = data.estudiantes.filter((a: any) => a.password === passwordValue);

	return (
		<Card title="Estudiante" style={{ width: '100%' }}>
			<Form
				name="basic"
				initialValues={{ remember: true }}
				onFinish={() => {
					if (match.length > 0) {
						setCustomLoader(true);
						axios
							.post(`${API_KEY}/auth/signInEstudiante`, {
								login: {
									uid: match[0].firebase_uid,
									hasuraKey: match[0].key,
									tipoUsuario: 'estudiante'
								}
							})
							.then(res => {
								firebase
									.auth()
									.signInWithCustomToken(res.data.token)
									.catch(function(error: any) {
										setCustomLoader(false);
										return error;
									});
							});
					} else {
						setCustomLoader(false);
						notificationService({ error: true }, 'Contraseña incorrecta, intenta de nuevo');
					}
				}}
				onFinishFailed={er => {
					notificationService({ error: true }, 'Contraseña incorrecta, intenta de nuevo');
				}}
			>
				<Form.Item
					label="Password"
					name="password"
					rules={[{ required: true, message: 'Please input your password!' }]}
				>
					<Input.Password
						onChange={e => {
							setPasswordValue(e.target.value);
						}}
						autoComplete="on"
						addonAfter={match.length > 0 && <CheckCircleTwoTone twoToneColor="#52c41a" />}
					/>
				</Form.Item>

				<Form.Item>
					<Button type="primary" htmlType="submit">
						Submit
					</Button>
				</Form.Item>
			</Form>
		</Card>
	);
};

export default SignInStudent;
